export default {
    state: {
        width: window.innerWidth,
        height: window.innerHeight,
        headerHeight: 0,
        footerHeight: 0,
        mobileWidth: 450,
        tabletWidth: 1281,
        collapsedWidth: 900,
        isCollapsed: false,
        isMobileApp: false,
    },
    mutations: {
        mut_resize: state => {
            state.width = window.innerWidth;
            state.height = window.innerHeight;
            state.isCollapsed = state.width < state.mobileWidth;
        },

        setHeaderHeight: (state, height) => state.headerHeight = height,

        setFooterHeight: (state, height) => state.footerHeight = height,
        setIsMobileApp: (state, bool) => state.isMobileApp = bool,
    },
    actions: {
        resize: ctx => ctx.commit('mut_resize'),
    },
    getters: {
        width: state => state.width,
        height: state => state.height || 0,
        headerHeight: state => state.headerHeight || 0,
        footerHeight: state => state.footerHeight || 0,
        contentHeight: (state, getters) => (getters.height - getters.headerHeight - getters.footerHeight),
        heightToFooter: (state, getters) => (getters.height - getters.headerHeight),
        is_collapsed: state => state.width < state.mobileWidth,
        is_menuCollapsed: state => state.width < state.collapsedWidth,
        isMobile: state => state.width < state.mobileWidth,
        mobile_width: state => state.mobileWidth,
        isMobileApp: state => state.isMobileApp,
        vh: (state) => state.height * 0.01,
    },
};
